import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LuxeNovaHome from "@/pages/LuxeNovaHome";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { bootstrapAnalytics } from "@/lib/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
    useEffect(() => {
        bootstrapAnalytics(BACKEND_URL);
    }, []);

    return (
        <I18nProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<LuxeNovaHome />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </BrowserRouter>
                <Toaster
                    position="top-center"
                    theme="dark"
                    richColors={false}
                    toastOptions={{
                        style: {
                            background: "#0A1A38",
                            color: "#E2E8F0",
                            border: "1px solid rgba(201,169,110,0.35)",
                            fontFamily: "Outfit, sans-serif",
                            letterSpacing: "0.02em",
                        },
                    }}
                />
            </div>
        </I18nProvider>
    );
}

export default App;
